export const initMessageObject = {
    show: false,
    title: "",
    message: "",
    messageType: "danger",
  }